<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-full">
          <h1 class="heading-xl">
            {{ $t('settings.heading') }}
          </h1>
          <al-list card data-test="user-id">
            <al-list-item v-if="showNationalId" wrap cta-icon="" name="item-settings-national-id">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('common.nationalId') }}
                  </p>
                  <p data-test="item-settings-national-id-text">
                    {{ nationalId | facade(nationalIdConfig.mask) }}
                  </p>
                </div>
              </div>
            </al-list-item>
            <al-list-item
              :aria-label="$t('settings.mobile')"
              aria-describedby="item-settings-mobile-description"
              data-test="item-settings-mobile"
              wrap
              name="editMobile"
              @click="$router.push({ name: ROUTES.CONTACT_INFORMATION_SETTINGS })">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('settings.contactInformation') }}
                  </p>
                  <p id="item-settings-mobile-description">
                    <span data-test="user-id-string">
                      {{ email }}
                    </span>
                    <br />
                    <span data-test="item-settings-mobile-text">
                      {{ mobileNumber }}
                    </span>
                  </p>
                </div>
              </div>
            </al-list-item>
            <al-list-item
              v-analytics:click="$EVENTS.LANGUAGE_SETTINGS"
              :aria-label="$t('settings.languageSelector')"
              wrap
              name="localeSelector"
              aria-describedby="item-settings-language-description"
              data-test="item-settings-language-selector"
              @click="$router.push({ name: ROUTES.LANGUAGE })">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('settings.languageSelector') }}
                  </p>
                  <p id="item-settings-country-and-language-description">
                    {{ country }}
                    <al-flag :country-code="countryCode" /> <br />
                    {{ language }}
                  </p>
                </div>
              </div>
            </al-list-item>
            <al-list-item
              :aria-label="$t('settings.connection')"
              wrap
              name="theme"
              aria-describedby="item-settings-theme-description"
              data-test="item-settings-theme"
              @click="$router.push({ name: ROUTES.THEME_SETTINGS })">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('settings.theme') }}
                  </p>
                  <p id="item-settings-theme-description">
                    {{ $t(theme) }}
                  </p>
                </div>
              </div>
            </al-list-item>
            <al-list-item
              :aria-label="$t('settings.connection')"
              wrap
              name="connections"
              aria-describedby="item-settings-connections-description"
              data-test="item-settings-connections"
              @click="$router.push({ name: ROUTES.CONNECTION_SETTINGS })">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('settings.connection') }}
                  </p>
                  <p id="item-settings-connections-description">
                    {{ $t('settings.connectionDescription') }}
                  </p>
                </div>
              </div>
            </al-list-item>
            <al-list-item
              :aria-label="$t('settings.profile')"
              wrap
              aria-describedby="item-settings-profile-description"
              data-test="item-settings-profile"
              name="profile"
              @click="$router.push({ name: ROUTES.PROFILE_SETTINGS })">
              <div class="row margin-left-none">
                <div class="col-full">
                  <p class="h3 margin-bottom-none">
                    {{ $t('settings.profile') }}
                  </p>
                  <p id="item-settings-profile-description">
                    {{ $t('settings.manageCard') }}
                  </p>
                </div>
              </div>
            </al-list-item>
          </al-list>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlFlag, AlList, AlListItem, Theme, getCurrentTheme } from '@mc-alberta/alcapone'
import { mapGetters, mapState } from 'vuex'
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.SETTINGS,
  components: { AlFlag, AlList, AlListItem },
  data() {
    return {
      ROUTES
    }
  },
  computed: {
    ...mapState({
      countryCode: (state) => state.user.consumer.countryCode,
      languageCode: (state) => state.user.consumer.languageCode,
      nationalId: (state) => state.user.consumer.nationalId
    }),
    ...mapGetters(['formattedUserEmail', 'formattedUserMobileNumber', 'locale']),
    email() {
      return this.formattedUserEmail
    },
    mobileNumber() {
      return this.formattedUserMobileNumber(this)
    },
    showNationalId() {
      return !!this.nationalId && !!this.nationalIdConfig
    },
    nationalIdConfig() {
      const { consumer } = this.$i18nData.getCountryConfig(this.countryCode)
      return consumer && consumer.nationalId
    },
    country() {
      const countryData = this.$i18nData.getTranslatedCountries(this.locale, [this.countryCode])
      return countryData[0] && countryData[0].label
    },
    language() {
      const languageData = this.$i18nData.getTranslatedLanguages(this.languageCode, [
        this.languageCode
      ])
      return languageData[0] && languageData[0].label
    },
    theme() {
      const appTheme = getCurrentTheme()
      let theme

      if (appTheme === Theme.DARK) {
        theme = 'themeSettings.darkMode'
      } else if (appTheme === Theme.SYSTEM) {
        theme = 'themeSettings.systemMode'
      } else {
        theme = 'themeSettings.lightMode'
      }

      return theme
    }
  }
}
</script>

<style scoped>
.list a {
  display: block;
  text-decoration: none;
}
</style>
